/**
 * saas-token.ts — In-memory holder for the ɳSentry SaaS session JWT.
 *
 * Purpose:    Bridge the httpOnly session cookie (set on sentry.nself.org) to
 *             the cross-origin SaaS API (api.sentry.nself.org). The cookie is
 *             NOT sent cross-origin, so saas-client must attach the JWT as an
 *             `Authorization: Bearer` header. The raw JWT is fetched from the
 *             same-origin /api/auth/session endpoint (after server-side
 *             signature verification) and kept here in module memory.
 * Inputs:     setSaasToken(token) — called by lib/api after login/session.
 * Outputs:    getSaasToken() — read by saas-client's request().
 * Constraints: Memory only (cleared on reload; re-hydrated by AuthProvider's
 *             mount getUser() call). Never persisted to localStorage — keeps
 *             the token out of durable storage while still surviving in-tab
 *             navigation. Cleared on sign-out.
 * SOT:        nsentry SaaS auth zone — dashboard data seam (W3)
 */

let token: string | null = null

/** Store (or clear, with null) the current session JWT. */
export function setSaasToken(next: string | null): void {
  token = next ?? null
}

/** Return the current session JWT, or null when logged out. */
export function getSaasToken(): string | null {
  return token
}
